function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "85.355%",
  y1: "14.645%",
  x2: "14.645%",
  y2: "85.355%",
  id: "a_mana"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF2D55",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFBC5B",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "49.966%",
  y1: "0%",
  x2: "49.966%",
  y2: "100%",
  id: "b_mana"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A524B3",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF2D55",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "url(#a_mana)",
  cx: 200,
  cy: 200,
  r: 200
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#b_mana)",
  d: "M125.7 0v150h125z",
  transform: "translate(16 130)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M16.7 280h125V130z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40 320c11.4 15.1 24.9 28.6 40 40h240c15.1-11.4 28.6-24.9 40-40H40z",
  fill: "#FC9965"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80 360c33.4 25.1 75 40 120 40s86.6-14.9 120-40H80z",
  fill: "#FF2D55"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#b_mana)",
  d: "M252.3 0v110H344z",
  transform: "translate(16 210)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M268.3 280H16.7c6.2 14.3 14.1 27.7 23.3 40h228.4v-40h-.1z",
  fill: "#FFBC5B"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M176.7 320h91.6V210z"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FFC95B",
  cx: 268.3,
  cy: 130,
  r: 50
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FFC95B",
  cx: 141.7,
  cy: 75,
  r: 25
}));

var SvgMana = function SvgMana(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMana, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mana.2b58efb7.svg";
export { ForwardRef as ReactComponent };